<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-5">
        <div class="col-12 row m-0 p-0">
          <div class="col-7">
            <img
              src="../Logo-GPI.png"
              class="rounded"
              width="150px"
            />
          </div>
          <div class="col-5  d-flex align-items-end">
            <span class="ft12Black">
              Fecha:
            </span>
            <span class="ft12">
              _________________________________
            </span>
          </div>
        </div>
        <div class="col-12 text-center my-3 py-2 bg-gpi-rojo">
          <span class="ft13Black text-white">
            DATOS DE FACTURACION
          </span>
        </div>
        <div class="col-12 text-justify">
          <br />
          <div class="row">
            <div class="col-3 text-right">
              <span class="ft12Black">Razón Social:</span>
            </div>
            <div class="col-9 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">RFC Homoclave:</span>
            </div>
            <div class="col-9 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-4 text-right">
              <span class="ft12Black">Representante Legal:</span>
            </div>
            <div class="col-8 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-6 text-right">
              <span class="ft12Black">Domicilio Fiscal</span>
            </div>
            <div class="col-6 "></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Calle:</span>
            </div>
            <div class="col-3 border-bottom border-dark"></div>
            <div class="col-1  m-0 p-0">
              <span class="ft11Black">Num Ext:</span>
            </div>
            <div class="col-2 border-bottom border-dark"></div>
            <div class="col-1  m-0 p-0">
              <span class="ft11Black">Num Int.</span>
            </div>
            <div class="col-2 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Colonia:</span>
            </div>
            <div class="col-5 border-bottom border-dark"></div>
            <div class="col-1">
              <span class="ft11Black">CP:</span>
            </div>
            <div class="col-3 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Delegación:</span>
            </div>
            <div class="col-5 border-bottom border-dark"></div>
            <div class="col-1">
              <span class="ft11Black">Estado:</span>
            </div>
            <div class="col-3 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Correo:</span>
            </div>
            <div class="col-9 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Método de pago:</span>
            </div>
            <div class="col-4 border-bottom border-dark"></div>
            <div class="col-3">
              <span class="ft11Black">Últimos 4 dígitos:</span>
            </div>
            <div class="col-2 border-bottom border-dark"></div>
          </div>
          <div class="row pt-1">
            <div class="col-3 text-right">
              <span class="ft12Black">Teléfono:</span>
            </div>
            <div class="col-4 border-bottom border-dark"></div>
          </div>
        </div>
        <div class="col-12 row pt-5">
          <div class="col-1 border border-dark rounded ml-5 pr-5 py-2"></div>
          <div class="col-6 py-2">
            <span class="ft13Black">No requiero factura </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div class="col-12 row pt-5">
          <div class="col-1 text-center"></div>
          <div class="col-5 text-center border-top border-dark pt-2">
            <span class="ft11Black">
              Firma del Cliente
            </span>
            <br /><br />
            <span class="ft11">
              * Todos los datos son obligatorios, solo si aplica.
            </span>
          </div>
          <div class="col-4 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/ContratosEmpleado/Caratura1/DatosFacturacion.vue